let resumeData = {
    "imagebaseurl":"",
    "name": "Shubham Dwivedi",
    "role": "Frontend Developer and Competitive Programmer",
    "linkedinId":"dwivedishubham545",
    "skypeid": "Your skypeid",
    "roleDescription": "I like dabbling in various parts of frontend development and like to learn about new technologies, write technical articles or simply play games in my free time.",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/dwivedishubham545/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"http://github.com/dwivedishubham545",
          "className":"fa fa-github"
        },
        {
          "name":"Instagram",
          "url":"https://www.instagram.com/dwivedishubham545/",
          "className":"fa fa-instagram"
        }
      ],
      "codeLinks":[
        {
          "name":"Leetcode",
          "url":"https://leetcode.com/dwivedishubham545/",
          "imgurl":"image/leetcode.png",
        },
        {
          "name":"Codeforces",
          "url":"https://codeforces.com/profile/dwivedishubham545",
          "imgurl":"image/codeforces.webp"
        },
        {
          "name":"GeekforGeeks",
          "url":"https://auth.geeksforgeeks.org/user/dwivedishubham545",
          "imgurl":"image/gfg.png"
        },
        {
          "name":"Codechef",
          "url":"https://www.codechef.com/users/dwivedishubham",
          "imgurl":"image/codechef.png"
        },
        {
          "name":"Hackerrank",
          "url":"https://www.hackerrank.com/profile/dwivedishubham",
          "imgurl":"image/hackerrank.png"
        }
      ],
    "aboutme":"I am currently a final year student at University Institute of Engineering and Technology, CSJMU Kanpur and pursuing my B.Tech from here. I am a self taught Front End Web Developer, Competitive Programmer. I believe that to be successful in life, one needs to be obsessive with their dreams and keep working towards them.",
    "address":"Kanpur , India",
    "website":"dwivedishubham545@gmail.com",
    "education":[
      {
        "UniversityName":"University Institute of Engineering and Technology, CSJMU Kanpur",
        "specialization":"Computer Science and Engineering",
        "MonthOfPassing":"May",
        "YearOfPassing":"2025",
        "Achievements":"CPI: 9.79 (Gold Medalist in CSE Department)"
      },
      {
        "UniversityName":"Prasad International School",
        "specialization":"PCM Intermediate",
        "MonthOfPassing":"March",
        "YearOfPassing":"2020",
        "Achievements":"Percentage: 94.8%"
      }
    ],
    "work":[
      {
        "CompanyName":"Oasis Infobyte",
        "specialization":"Intern",
        "MonthOfLeaving":"August",
        "YearOfLeaving":"2023",
        "Achievements":""
      },
      {
        "CompanyName":"InternPe",
        "specialization":"Intern",
        "MonthOfLeaving":"July",
        "YearOfLeaving":"2023",
        "Achievements":""
      }
    ],
    "skillsDescription":"My skills here",
    "skills":[
      {
        "skillname":"Competitive Programming: C/C++ , Java , Python"
      },
      {
        "skillname":"Front End Web Development: HTML , CSS , JS , React , Bootstrap , API"
      },
      {
        "skillname":"Database: MySql"
      },
      {
        "skillname":"Tools: VScode , Github , MySQL Workbench , Xampp "
      },
    ],
    "portfolio":[
      {
        "imgurl":"image/Blog.png",
        "url":"https://github.com/dwivedishubham545/Blog-App/",
        "name":"Blog Application",
        "description":"MERN Stack"
      },
      {
        "imgurl":"image/hostel.png",
        "url":"https://github.com/dwivedishubham545/Hostel-Management/",
        "name":"Hostel Management",
        "description":"DBMS Project(Full Stack)"
      },
      {
        "name":"Code-Editor",
        "description":"Web Application",
        "imgurl":"image/code-editor.png",
        "url":"https://github.com/dwivedishubham545/code-editor"
      },
      {
        "name":"Myshop",
        "description":"Web Application",
        "imgurl":"image/ecommerce.jpg",
        "url":"https://github.com/dwivedishubham545/Myshop"
      },
      {
        "imgurl":"image/travel.jpg",
        "url":"https://dwivedishubham545.github.io/Travel/",
        "name":"Travel",
        "description":"Web Application"
      },
      {
        "name":"Weather",
        "description":"Web Application",  
        "imgurl":"image/weather.jpg",
        "url":"https://dwivedishubham545.github.io/Weather-app/"
      },
      {
        "name":"Covid",
        "description":"Web Application",  
        "imgurl":"image/covid.avif",
        "url":"https://dwivedishubham545.github.io/Covid/"
      },
      {
        "name":"To-Do List",
        "description":"Web Application",  
        "imgurl":"image/to-do.png",
        "url":"https://github.com/dwivedishubham545/OIBSIP/tree/main/To-Do%20List/"
      },
     {
        "name":"Basic Computer",
        "description":"Logisim Circuit",  
        "imgurl":"image/Logisim.png",
        "url":"https://github.com/dwivedishubham545/Computer-1-Computer-Organisation/"
      },
     {
        "name":"Microprogrammed Control Computer",
        "description":"Logisim Circuit",  
        "imgurl":"image/Logisim.png",
        "url":"https://github.com/dwivedishubham545/Computer-2-Computer-Organisation/"
      },
    ],
    "testimonials":[
      {
        "description":"Any fool can write code that a computer can understand. Good programmers write code that humans can understand",
        "name":"Martin Fowler"
      },
      {
        "description":"The best way to predict the future is to invent it.",
        "name":"Alan Kay"
      },
      {
        "description":"Software is a great combination of artistry and engineering.",
        "name":" Bill Gates"
      },
      {
        "description":"The only way to do great work is to love what you do.",
        "name":" Steve Jobs"
      },
      {
        "description":"Debugging is like being the detective in a crime movie where you're also the murderer.",
        "name":"Filipe Fortes"
      },
      {
        "description":"The computer was born to solve problems that did not exist before.",
        "name":"Bill Gates"
      }
    ]
  }
  
  export default resumeData
